import { i18n } from "../../../language";
import store from "../../../store/";

let isDarkMode = () => store.state.user.darkMode;

export default function getData(data) {
    return {
        legend: {
            show: true,
            orient: "vertical",
            left: 0,
            textStyle: {
                color: isDarkMode() ? "white" : "black",
            },
        },
        toolbox: {
            feature: {
                saveAsImage: {
                    pixelRatio: 2,
                    title: i18n.t("message.download"),
                },
            },
        },
        series: [
            {
                type: "pie",
                radius: ["40%", "70%"],
                avoidLabelOverlap: false,
                itemStyle: {
                    borderRadius: 20,
                    borderColor: "#fff",
                    borderWidth: 2,
                },
                label: {
                    show: false,
                    position: "center",
                },
                emphasis: {
                    label: {
                        show: true,
                        fontSize: "40",
                        fontWeight: "bold",
                    },
                },
                labelLine: {
                    show: false,
                },
                data,
            },
        ],
    };
}
